/* components/SiteHeader.ts
Global Site Header

Example
<site-header>
    Site header content here
</site-header>
*/

import { AnnouncementBar } from '../AnnouncementBar/AnnouncementBar';
import { CartMain } from "../Cart/CartMain";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { debounce } from 'lodash';
import { SideCart } from '../SideCart/SideCart';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerContainer } from '../Drawer/DrawerContainer';
import { DrawerHamburger } from '../Drawer/DrawerHamburger';
import { cart } from '@/theme/Cart';

@Component
export class SiteHeader extends ThemeComponent {
    @Ref() row!: HTMLDivElement;
    @Ref({required: false}) cartTrigger!: HTMLDivElement;
    @Ref() menuToggle!: DrawerHamburger[];
    @Ref({required: false}) count!: HTMLElement;
    @Ref({ required: false }) announcement!: AnnouncementBar;
    @Ref mobileMenu !: DrawerContainer;
    @Ref searchTrigger !: HTMLButtonElement;
    @Ref searchForm !: HTMLInputElement;

    private _onOpenChange = new SimpleEvent<string>();
    private sideCart:SideCart|null = document.body.querySelector('side-cart');

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        // Use the private backing field to dispatch
        this._onOpenChange.dispatch('');
    }

    init() {
        this.handleBodyPadding();
        this.setEventListeners();
        this.handleSearchBar();
        this.listenForOuterDrawerClick();

        const cartMain = document.body.querySelector('cart-main') as CartMain;
        document.addEventListener('cartChanged', (e: Event) => {
            this.updateCartCount();
        });
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        this.$listen(window, 'resize',
            debounce(() => {
                this.handleBodyPadding();
            }, 300)
        );

        this.handleScroll();
        this.cartEvent();
    }

    /**
     * Handle Body Paddin
     */

    private handleSearchBar() {
        this.$listen(this.searchTrigger, 'click', () => {
            document.dispatchEvent(new Event('searchOpen'));
        });

        document.addEventListener('searchOpen', () => {
            document.body.classList.add('search-open');
            this.searchForm.focus();
            document.dispatchEvent(new Event('hamburgerOpen'));
        });

        document.addEventListener('searchClose', () => {
            document.body.classList.remove('search-open');
            document.dispatchEvent(new Event('hamburgerClose'));
        });
    }

    public listenForOuterDrawerClick() {
        this.$listen(this, 'click', (e) => {
            if (e.target) {
                const clickedElement = e.target as HTMLElement;
                if (clickedElement === this) {
                    document.body.classList.remove('drawer-open','search-open');
                    document.dispatchEvent(new Event('closeMenu'));
                    document.dispatchEvent(new Event('hamburgerClose'));
                }
            }
        });
    }

    private handleBodyPadding() {
        const height = this.parentElement?.offsetHeight;

        document.documentElement.style.paddingTop = `${height}px`;
    }

    private handleScroll() {
        const headerHeight = this.offsetHeight;
        const header = this.closest('header');
        let prevScrollY = window.pageYOffset || document.documentElement.scrollTop;

        window.addEventListener('scroll', () => {
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollY > headerHeight && currentScrollY < prevScrollY) {
                header?.classList.add('site-header--up');
                header?.classList.remove('site-header--down');
            } else if (currentScrollY > headerHeight && currentScrollY > prevScrollY) {
                header?.classList.add('site-header--down');
                header?.classList.remove('site-header--up');
            } else {
                header?.classList.remove('site-header--up');
                header?.classList.remove('site-header--down');
            }

            prevScrollY = currentScrollY;
        });
    }



    /**
     * Cart Close click event.
     * @returns
     */
    cartEvent() {
        if (!this.cartTrigger) { return; }
        this.$listen(this.cartTrigger, 'click', (event) => {
            event.preventDefault();

            if (!this.sideCart) { return; }
            this.sideCart.open();
        });
    }

    /**
     * Update cart count
     * @returns
     */
    private updateCartCount() {
        const count = cart.getCartItemCount();
        this.count.innerHTML = String(count);
        if (count > 0) {
            this.count.parentElement?.classList.add('is-active');
        } else {
            this.count.parentElement?.classList.remove('is-active');
        }
    }
}
